import "react-toastify/dist/ReactToastify.css";

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { redirectIfAuthed, redirectIfUnauthed } from "./hocs/authRedirects";

import AdminAppBar from "./components/AdminAppBar";
import AffiliateDetailPage from "./pages/AffiliateDetailPage";
import AffiliateListPage from "./pages/AffiliateListPage";
import BankAccountDetailPage from "./pages/BankAccountDetailPage";
import CardDetailPage from "./pages/CardDetailPage";
import CreditMonitoringDetailPage from "./pages/CreditMonitoringDetailPage";
import CssBaseline from "@material-ui/core/CssBaseline";
import CustomerDetailPage from "./pages/CustomerDetailPage/CustomerDetailPage";
import CustomersListPage from "./pages/CustomersListPage";
import IdentityDetailPage from "./pages/IdentityDetailPage";
import IdentityListPage from "./pages/IdentityListPage";
import DashboardPage from "./pages/DashboardPage";
import DayjsUtils from "@date-io/dayjs";
import EnrollmentVerificationDetailPage from "./pages/EnrollmentVerificationDetailPage/EnrollmentVerificationDetailPage";
import EnrollmentVerificationsListPage from "./pages/EnrollmentVerificationsListPage";
import FurnishmentDetailPage from "./pages/FurnishmentDetailPage";
import FurnishmentsListPage from "./pages/FurnishmentsListPage";
import InvoiceDetailPage from "./pages/InvoiceDetailPage";
import InvoicesListPage from "./pages/InvoicesListPage";
import ApplicantDetailPage from "./pages/ApplicantDetailPage/ApplicantDetailPage";
import ApplicationDetailPage from "./pages/ApplicationDetailPage/ApplicationDetailPage";
import KybVerificationDetailPage from "./pages/KybVerificationDetailPage/KybVerificationDetailPage";
import KybVerificationsListPage from "./pages/KybVerificationsListPage";
import { LoadingProvider } from "./hooks/loading";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import PartnerDetailPage from "./pages/PartnerDetailPage/PartnerDetailPage";
import PartnerUserDetailPage from "./pages/PartnerUserDetailPage/PartnerUserDetailPage";
import PartnerPayoutsPage from "./pages/PartnerPayoutsPage/PartnerPayoutsPage";
import PartnerInvoicesPage from "./pages/PartnerInvoicesPage/PartnerInvoicesPage";
import PartnerdListPage from "./pages/PartnerListPage";
import PaymentDetailPage from "./pages/PaymentDetailPage";
import PaymentVerificationDetailPage from "./pages/PaymentVerificationPage/PaymentVerificationDetailPage";
import PaymentsListPage from "./pages/PaymentsListPage";
import PayoutDetailPage from "./pages/PayoutDetailPage";
import PayoutsListPage from "./pages/PayoutsListPage";
import ApplicationListPage from "./pages/ApplicationListPage/ApplicationListPage";
import React from "react";
import { Redirect } from "react-router";
import RentalVerificationDetailPage from "./pages/RentalVerificationDetailPage";
import ReportingAccountEnrollmentDetailPage from "./pages/ReportingAccountEnrollmentDetailPage/ReportingAccountEnrollmentDetailPage";
import ReportingAccountEnrollmentsListPage from "./pages/ReportingAccountEnrollmentsListPage";
import { ChimePaymentVerificationDetailPage } from "./pages/ChimePaymentVerificationPage";
import { ChimeVerifiedEnrollmentsListPage } from "./pages/ChimeVerifiedEnrollmentsListPage";
import PmsTransactionsPage from "./pages/PmsTransactionsPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import ForcedPasswordChangeGate from "./components/ForcedPasswordChangeGate";
import RootPage from "./pages/RootPage";
import SignInPage from "./pages/SignInPage";
import { ThemeProvider } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";
import TradelineDetailPage from "./pages/TradelineDetailPage/TradelineDetailPage";
import { UserProvider } from "./hooks/user";
import { VerifiedEnrollmentsListPage } from "./pages/VerifiedEnrollmentsListPage";
import applyHocs from "./lithic/applyHocs";
import theme from "./theme";
import withParamsKey from "./lithic/withParamsKey";
import { VerificationIdPage } from "./pages/VerificationIdPage";
import { ChatsPage } from "./pages/ChatsPage";
import StatementDetailPage from "./pages/StatementDetailPage";
import { ChatProvider } from "./providers/ChatProvider";
import StatementsListPage from "./pages/StatementsListPage";
import AggregatedPaymentsListPage from "./pages/AggregatedPaymentsListPage";
import AggregatedPaymentDetailPage from "./pages/AggregatedPaymentDetailPage";
import AggregatePaymentsPage from "./pages/AggregatePaymentsPage";
import PmsRequestLogsPage from "./pages/PmsRequestLogsPage";
import ApplicantAlertsPage from "./pages/ApplicantAlertsPage";
import BulkUploadsListPage from "./pages/BulkUploadsListPage";
import ExclusionListPage from "./pages/ExclusionListPage";
import LeadImportsPage from "./pages/LeadImportsPage";
import UniversalExclusionListPage from "./pages/UniversalExclusionListPage";
import PmsChargesListPage from "./pages/PmsChargesListPage";
import WebhookRequestsListPage from "./pages/PartnerDetailPage/components/WebhookRequestsListPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import WorkflowAnalyticsPage from "./pages/WorkflowAnalyticsPage";
import ScheduleHealthPage from "./pages/ScheduleHealthPage";
import ProvisionedPhoneNumbersPage from "./pages/ProvisionedPhoneNumbersPage";
import WorkflowExecutionLogPage from "./pages/WorkflowExecutionLogPage";
import WorkflowExecutionDetailPage from "./pages/WorkflowExecutionDetailPage";
import BoomReportPage from "./pages/BoomReportPage";
import BssRunsPage from "./pages/Bss/RunsPage";
import BssRunDetailPage from "./pages/Bss/RunDetailPage";
import BssTicketsPage from "./pages/Bss/TicketsPage";
import BssTicketDetailPage from "./pages/Bss/TicketDetailPage";
import BssQaWorkspacePage from "./pages/Bss/QaWorkspacePage";
import BssGroupDetailPage from "./pages/Bss/GroupDetailPage";
import BssStatsPage from "./pages/Bss/StatsPage";
import BssSettingsPage from "./pages/Bss/SettingsPage";
import BssBrainPage from "./pages/Bss/BrainPage";
import BssKnowledgePage from "./pages/Bss/KnowledgePage";
import BssRejectionsPage from "./pages/Bss/RejectionsPage";
import DevToolsIndexPage from "./pages/dev/DevToolsIndexPage";
import { DEV_TOOLS, devToolPath } from "./pages/dev/registry";
import BssQaFlowsPage from "./pages/Bss/QaFlowsPage";
import BssReleaseRunReport from "./pages/Bss/ReleaseRunReport";

const NavSwitch = () => {
  return (
    <Switch>
      <Route path="/" exact render={() => null} />
      <Route component={AdminAppBar} />
    </Switch>
  );
};

export default function App() {
  return (
    <Router>
      <UserProvider>
        <LoadingProvider>
          <ChatProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <MuiPickersUtilsProvider utils={DayjsUtils}>
                <main>
                  <ForcedPasswordChangeGate>
                    <NavSwitch />
                    <PageSwitch />
                  </ForcedPasswordChangeGate>
                </main>
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </ChatProvider>
        </LoadingProvider>
      </UserProvider>
      <ToastContainer hideProgressBar={true} />
    </Router>
  );
}

function PageSwitch() {
  return (
    <Switch>
      <Route exact path="/" component={RootPage} />
      <Route
        exact
        path="/sign-in"
        component={applyHocs(redirectIfAuthed, SignInPage)}
      />
      <Route
        exact
        path="/dashboard"
        component={applyHocs(redirectIfUnauthed, DashboardPage)}
      />
      <Route
        exact
        path="/account/change-password"
        component={applyHocs(redirectIfUnauthed, ChangePasswordPage)}
      />
      <Route
        exact
        path="/affiliates"
        component={applyHocs(redirectIfUnauthed, AffiliateListPage)}
      />
      <Route
        exact
        path="/affiliates/:id"
        component={applyHocs(redirectIfUnauthed, AffiliateDetailPage)}
      />
      <Route
        exact
        path="/partners"
        component={applyHocs(redirectIfUnauthed, PartnerdListPage)}
      />
      <Route
        exact
        path="/partners/:id/users/:userId"
        component={applyHocs(redirectIfUnauthed, PartnerUserDetailPage)}
      />
      <Route
        exact
        path="/partners/:id/exclusions"
        component={applyHocs(redirectIfUnauthed, ExclusionListPage)}
      />
      <Route
        exact
        path="/partners/:id/pms-charges"
        component={applyHocs(redirectIfUnauthed, PmsChargesListPage)}
      />
      <Route
        exact
        path="/partners/:id/webhook-requests"
        component={applyHocs(redirectIfUnauthed, WebhookRequestsListPage)}
      />
      <Route
        exact
        path="/partners/:id/lead-imports"
        component={applyHocs(redirectIfUnauthed, LeadImportsPage)}
      />
      <Route
        exact
        path="/agent"
        component={applyHocs(redirectIfUnauthed, AnalyticsPage)}
      />
      <Route
        exact
        path="/partners/:id"
        component={applyHocs(redirectIfUnauthed, PartnerDetailPage)}
      />
      <Route
        exact
        path="/partners/:id/invoices"
        component={applyHocs(redirectIfUnauthed, PartnerInvoicesPage)}
      />
      <Route
        exact
        path="/partners/:id/payouts"
        component={applyHocs(redirectIfUnauthed, PartnerPayoutsPage)}
      />
      <Route
        exact
        path="/partners/:id/statement/:statement_id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          withParamsKey("statement_id"),
          StatementDetailPage
        )}
      />
      <Route
        exact
        path="/statements/:statement_id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          withParamsKey("statement_id"),
          StatementDetailPage
        )}
      />
      <Route
        exact
        path="/customers"
        component={applyHocs(redirectIfUnauthed, CustomersListPage)}
      />
      <Route
        exact
        path="/customers/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          CustomerDetailPage
        )}
      />
      <Route
        exact
        path="/identities"
        component={applyHocs(redirectIfUnauthed, IdentityListPage)}
      />
      <Route
        exact
        path="/identities/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          IdentityDetailPage
        )}
      />
      <Route
        exact
        path="/credit-monitorings/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          CreditMonitoringDetailPage
        )}
      />
      <Route
        exact
        path="/payments"
        component={applyHocs(redirectIfUnauthed, PaymentsListPage)}
      />
      <Route
        exact
        path="/payments/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          PaymentDetailPage
        )}
      />
      <Route
        exact
        path="/invoices"
        component={applyHocs(redirectIfUnauthed, InvoicesListPage)}
      />
      <Route
        exact
        path="/invoices/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          InvoiceDetailPage
        )}
      />
      <Route
        exact
        path="/payouts"
        component={applyHocs(redirectIfUnauthed, PayoutsListPage)}
      />
      <Route
        exact
        path="/payouts/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          PayoutDetailPage
        )}
      />
      <Route
        exact
        path="/reporting-account-enrollments"
        component={applyHocs(
          redirectIfUnauthed,
          ReportingAccountEnrollmentsListPage
        )}
      />
      <Route
        exact
        path="/reporting-account-enrollments/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          ReportingAccountEnrollmentDetailPage
        )}
      />
      <Route
        exact
        path="/tradelines/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          TradelineDetailPage
        )}
      />
      <Route
        exact
        path="/reporting-account-enrollments/:id/payment-verifications"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          PaymentVerificationDetailPage
        )}
      />
      <Route
        exact
        path="/enrollment-verifications"
        component={applyHocs(
          redirectIfUnauthed,
          EnrollmentVerificationsListPage
        )}
      />
      <Route
        exact
        path="/rental-verifications/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          RentalVerificationDetailPage
        )}
      />
      <Route
        exact
        path="/bank-accounts/:id"
        component={applyHocs(redirectIfUnauthed, BankAccountDetailPage)}
      />
      <Route
        exact
        path="/cards/:id"
        component={applyHocs(redirectIfUnauthed, CardDetailPage)}
      />
      <Route
        exact
        path="/furnishments"
        component={applyHocs(redirectIfUnauthed, FurnishmentsListPage)}
      />
      <Route
        exact
        path="/furnishments/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          FurnishmentDetailPage
        )}
      />
      <Route
        exact
        path="/enrollment-verifications/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          EnrollmentVerificationDetailPage
        )}
      />
      <Route
        exact
        path="/payment-verifications"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          VerifiedEnrollmentsListPage
        )}
      />
      <Route
        exact
        path="/chime-verifications"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          ChimeVerifiedEnrollmentsListPage
        )}
      />

      <Route
        exact
        path="/reporting-account-enrollments/:id/chime-payment-verifications"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          ChimePaymentVerificationDetailPage
        )}
      />
      <Route
        exact
        path="/customers/:id/pms-transactions"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          PmsTransactionsPage
        )}
      />
      <Route
        exact
        path="/kyb-verifications"
        component={applyHocs(redirectIfUnauthed, KybVerificationsListPage)}
      />

      <Route
        exact
        path="/statements"
        component={applyHocs(redirectIfUnauthed, StatementsListPage)}
      />
      <Route
        exact
        path="/aggregated-payments"
        component={applyHocs(redirectIfUnauthed, AggregatedPaymentsListPage)}
      />
      <Route
        exact
        path="/aggregated-payments/new"
        component={applyHocs(redirectIfUnauthed, AggregatePaymentsPage)}
      />
      <Route
        exact
        path="/aggregated-payments/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          AggregatedPaymentDetailPage
        )}
      />
      <Route
        exact
        path="/kyb-verifications/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          KybVerificationDetailPage
        )}
      />
      <Route
        exact
        path="/applications"
        component={applyHocs(redirectIfUnauthed, ApplicationListPage)}
      />
      <Route
        exact
        path="/applications/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          ApplicationDetailPage
        )}
      />

      <Route
        exact
        path="/chats"
        component={applyHocs(redirectIfUnauthed, ChatsPage)}
      />
      <Route
        exact
        path="/pms-request-logs"
        component={applyHocs(redirectIfUnauthed, PmsRequestLogsPage)}
      />
      <Route
        exact
        path="/applicant-alerts"
        component={applyHocs(redirectIfUnauthed, ApplicantAlertsPage)}
      />
      <Route
        exact
        path="/provisioned-phone-numbers"
        component={applyHocs(redirectIfUnauthed, ProvisionedPhoneNumbersPage)}
      />
      <Route
        exact
        path="/workflow-analytics"
        component={applyHocs(redirectIfUnauthed, WorkflowAnalyticsPage)}
      />
      <Route
        exact
        path="/workflow-analytics/schedule-health"
        component={applyHocs(redirectIfUnauthed, ScheduleHealthPage)}
      />
      <Route
        exact
        path="/workflow-execution-log"
        component={applyHocs(redirectIfUnauthed, WorkflowExecutionLogPage)}
      />
      <Route
        exact
        path="/workflow-execution-log/:executionId"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("executionId"),
          WorkflowExecutionDetailPage
        )}
      />
      <Route
        exact
        path="/bulk-uploads"
        component={applyHocs(redirectIfUnauthed, BulkUploadsListPage)}
      />
      <Route
        exact
        path="/universal-exclusions"
        component={applyHocs(redirectIfUnauthed, UniversalExclusionListPage)}
      />
      <Route
        exact
        path="/applicants/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          ApplicantDetailPage
        )}
      />
      <Route
        path="/applicants/:id/verifications/:verificationId"
        render={() => <VerificationIdPage />}
      />
      <Route
        exact
        path="/boom-report"
        component={applyHocs(redirectIfUnauthed, BoomReportPage)}
      />
      <Route
        exact
        path="/bss"
        component={applyHocs(redirectIfUnauthed, BssRunsPage)}
      />
      <Route
        exact
        path="/bss/runs/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          BssRunDetailPage
        )}
      />
      <Route
        exact
        path="/bss/groups/:id"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("id"),
          BssGroupDetailPage
        )}
      />
      <Route
        exact
        path="/bss/tickets"
        component={applyHocs(redirectIfUnauthed, BssTicketsPage)}
      />
      <Route
        exact
        path="/bss/tickets/:key"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("key"),
          BssTicketDetailPage
        )}
      />
      <Route
        exact
        path="/bss/tickets/:key/qa"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("key"),
          BssQaWorkspacePage
        )}
      />
      {/* The Investigator's Jira web link deep-links here; the Investigation
          panel renders on the ticket detail page, so this is an alias. */}
      <Route
        exact
        path="/bss/tickets/:key/investigation"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("key"),
          BssTicketDetailPage
        )}
      />
      <Route
        exact
        path="/bss/brain"
        component={applyHocs(redirectIfUnauthed, BssBrainPage)}
      />
      <Route
        exact
        path="/bss/knowledge"
        component={applyHocs(redirectIfUnauthed, BssKnowledgePage)}
      />
      <Route
        exact
        path="/bss/rejections"
        component={applyHocs(redirectIfUnauthed, BssRejectionsPage)}
      />
      <Route
        exact
        path="/bss/qa-flows"
        component={applyHocs(redirectIfUnauthed, BssQaFlowsPage)}
      />
      <Route
        exact
        path="/bss/release-tests/:releaseKey"
        component={applyHocs(
          redirectIfUnauthed,
          withParamsKey("releaseKey"),
          BssReleaseRunReport
        )}
      />
      <Route
        exact
        path="/bss/overview"
        component={applyHocs(redirectIfUnauthed, BssStatsPage)}
      />
      <Route
        exact
        path="/bss/settings"
        component={applyHocs(redirectIfUnauthed, BssSettingsPage)}
      />
      {/* Legacy /jira-agent/* URLs — keep them working so existing bookmarks
          and Jira "Web links" posted by past IA runs still resolve. Caught
          by a single Route + computed Redirect so subpath, query, and hash
          are preserved verbatim. Safe to remove after a couple of months
          once cached bookmarks have aged out + Jira links have been
          re-upserted (the IA-side `globalId` upsert will replace each old
          /jira-agent/... entry the next time IA runs on its ticket). */}
      <Route
        path="/jira-agent"
        render={({ location }) => (
          <Redirect
            to={{
              ...location,
              pathname: location.pathname.replace(/^\/jira-agent/, "/bss")
            }}
          />
        )}
      />
      <Route
        exact
        path="/dev"
        component={applyHocs(redirectIfUnauthed, DevToolsIndexPage)}
      />
      {DEV_TOOLS.map((tool) => (
        <Route
          key={tool.slug}
          exact
          path={devToolPath(tool.slug)}
          component={applyHocs(redirectIfUnauthed, tool.component)}
        />
      ))}
      <Route path="*" render={() => <Redirect to="/" />} />
    </Switch>
  );
}
